/**
 * メイン シーン
 */

import Phaser from 'phaser';

import Manager from '../../../game/manager/main';
import PlayData from '../../../game/playdata/main';

import GetList from '../../../game/display/getlist/main';
import Eggs from '../../../game/display/eggs/main';
import Birth from '../../../game/display/birth/main';
import GameUI from '../../../game/display/ui/main';
import Telop from '../../../game/display/telop/main';



export default class Playing extends Phaser.Scene{

    constructor(){
        super({key: 'Game1Playing'});
    }


    /**
     * シーン開始時処理 (LifeCycle Methods)
     */
    create(){
        GAME_REF.scene = this;

        this.manager = new Manager();
        this.data = new PlayData();

        this._setDisplay();
        this.cameras.main.fadeIn(700, 0, 0, 0);
    }


    /**
     * 描画更新処理 (LifeCycle Methods)
     */
    update(time, delta){ 
    }


    shutdown(){
        this.tweens.killAll();
        this.scene.stop();
        this.scene.remove();
    }


    nextScene(){
        this.scene.start('Game1Clear', {score: this.manager.data._score});
    }
    

    _setDisplay(){
        this.eggs = new Eggs();
        this.getList = new GetList();
        this.birth = new Birth();
        this.ui = new GameUI();
        this.telop = new Telop();
        this.manager.init();
    }
}
